import { CHECK_STATUSES } from '../constants/appConstants';

/**
 * Whether check-item remove controls are shown (cashiering / client-detail checks layout).
 * Removing items requires the dedicated `remove_check_item` permission — it is
 * intentionally NOT implied by `canManageChecks` (same pattern as check discounts),
 * so a manager must grant it explicitly for employees to see/use the control.
 */
export function resolveShowRemoveButton({
  showOrderColumn,
  canRemoveCheckItem,
  isClient,
  checkStatus,
}) {
  if (showOrderColumn) return Boolean(canRemoveCheckItem);
  return !isClient && checkStatus !== CHECK_STATUSES.CLOSED;
}
